"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonNova = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Linked = require("./Linked");
var _TextElementNova = require("./TextElementNova");
var _segmentfunctions = require("../utils/segmentfunctions");
var _ButtonNova = require("./ButtonNova.styled");
var _excluded = ["level", "ctaLink", "icon", "className", "label", "size", "width", "srlabel", "loading", "disabled", "trackObject", "onClick", "copyClassName", "children", "customIcon"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var ArrowIconPrimary = function ArrowIconPrimary(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    className: "bg",
    d: "M0 3.2c0-1.12 0-1.68.218-2.108a2 2 0 0 1 .874-.874C1.52 0 2.08 0 3.2 0h17.6c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C24 1.52 24 2.08 24 3.2v17.6c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C22.48 24 21.92 24 20.8 24H3.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C0 22.48 0 21.92 0 20.8V3.2Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "arrow",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m13.154 7.647-.354-.354-.707.707.354.354 3.146 3.146H6.7v1h8.894l-3.147 3.146-.354.354.707.707.354-.353 4-4a.5.5 0 0 0 0-.707l-4-4Z",
    fill: "#fff"
  }));
};
ArrowIconPrimary.defaultProps = {
  width: "24",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var ArrowIconTextlink = function ArrowIconTextlink(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.154 3.647 8.8 3.293 8.093 4l.354.354 3.146 3.145H2.7v1h8.894l-3.147 3.147-.354.354.707.707.354-.353 4-4a.5.5 0 0 0 0-.707l-4-4Z",
    fill: "#007A73",
    className: "arrow"
  }));
};
ArrowIconTextlink.defaultProps = {
  width: "16",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var LoadingIconPrimary = function LoadingIconPrimary(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", {
    clipPath: "url(#a)",
    fill: "#fff"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".2",
    d: "M4.42 1.62C5.62.9 7.06.5 8.5.5v.8c-1.28 0-2.56.32-3.6.96l-.48-.64Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".3",
    d: "M1.54 4.5c.72-1.2 1.68-2.16 2.88-2.88l.48.64c-1.12.64-2 1.52-2.64 2.64l-.72-.4Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".4",
    d: "M2.26 4.9c-.64 1.04-.96 2.32-.96 3.6H.5c0-1.44.4-2.8 1.04-4l.72.4Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".5",
    d: "M1.3 8.5c0 1.28.32 2.56.96 3.6l-.64.48A8.015 8.015 0 0 1 .5 8.5h.8Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".6",
    d: "M4.5 15.46a8.273 8.273 0 0 1-2.88-2.88l.64-.48c.64 1.12 1.52 2 2.64 2.64l-.4.72Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".7",
    d: "M8.5 16.5c-1.44 0-2.8-.4-4-1.04l.4-.72c1.04.64 2.32.96 3.6.96v.8Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".9",
    d: "M12.1 14.74c1.12-.64 2-1.52 2.64-2.64l.72.4a8.273 8.273 0 0 1-2.88 2.88l-.48-.64Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".8",
    d: "M8.5 15.7c1.28 0 2.56-.32 3.6-.96l.48.64c-1.2.72-2.64 1.12-4.08 1.12v-.8Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".1",
    d: "M12.1 2.26c-1.04-.64-2.32-.96-3.6-.96V.5c1.44 0 2.8.4 4 1.04l-.4.72Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.7 8.9c0-.24.24-.4.4-.4.24 0 .4.24.4.4-.08 1.28-.48 2.48-1.04 3.6l-.72-.4c.56-.96.88-2.08.96-3.2Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".05",
    d: "M15.22 4.1c.16.16.08.4-.08.56-.16.16-.4.08-.56-.08a7.624 7.624 0 0 0-2.48-2.32l.4-.72c1.04.64 2 1.52 2.72 2.56Z"
  })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#fff",
    transform: "translate(.5 .5)",
    d: "M0 0h16v16H0z"
  }))));
};
LoadingIconPrimary.defaultProps = {
  width: "17",
  height: "17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var LoadingIconSecondary = function LoadingIconSecondary(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    clipPath: "url(#b)",
    fill: "#007A73"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".2",
    d: "M4.42 1.12C5.62.4 7.06 0 8.5 0v.8c-1.28 0-2.56.32-3.6.96l-.48-.64Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".3",
    d: "M1.54 4c.72-1.2 1.68-2.16 2.88-2.88l.48.64c-1.12.64-2 1.52-2.64 2.64L1.54 4Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".4",
    d: "M2.26 4.4C1.62 5.44 1.3 6.72 1.3 8H.5c0-1.44.4-2.8 1.04-4l.72.4Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".5",
    d: "M1.3 8c0 1.28.32 2.56.96 3.6l-.64.48A8.015 8.015 0 0 1 .5 8h.8Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".6",
    d: "M4.5 14.96a8.273 8.273 0 0 1-2.88-2.88l.64-.48c.64 1.12 1.52 2 2.64 2.64l-.4.72Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".7",
    d: "M8.5 16c-1.44 0-2.8-.4-4-1.04l.4-.72c1.04.64 2.32.96 3.6.96v.8Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".9",
    d: "M12.1 14.24c1.12-.64 2-1.52 2.64-2.64l.72.4a8.273 8.273 0 0 1-2.88 2.88l-.48-.64Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".8",
    d: "M8.5 15.2c1.28 0 2.56-.32 3.6-.96l.48.64C11.38 15.6 9.94 16 8.5 16v-.8Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".1",
    d: "M12.1 1.76C11.06 1.12 9.78.8 8.5.8V0c1.44 0 2.8.4 4 1.04l-.4.72Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.7 8.4c0-.24.24-.4.4-.4.24 0 .4.24.4.4-.08 1.28-.48 2.48-1.04 3.6l-.72-.4c.56-.96.88-2.08.96-3.2Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".05",
    d: "M15.22 3.6c.16.16.08.4-.08.56-.16.16-.4.08-.56-.08a7.624 7.624 0 0 0-2.48-2.32l.4-.72c1.04.64 2 1.52 2.72 2.56Z"
  }))), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h16v16H0z"
  })), /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h16v16H0z"
  }))));
};
LoadingIconSecondary.defaultProps = {
  width: "17",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var LoadingIconTertiary = function LoadingIconTertiary(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    clipPath: "url(#b)",
    fill: "#041C1B"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".2",
    d: "M4.42 1.12C5.62.4 7.06 0 8.5 0v.8c-1.28 0-2.56.32-3.6.96l-.48-.64Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".3",
    d: "M1.54 4c.72-1.2 1.68-2.16 2.88-2.88l.48.64c-1.12.64-2 1.52-2.64 2.64L1.54 4Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".4",
    d: "M2.26 4.4C1.62 5.44 1.3 6.72 1.3 8H.5c0-1.44.4-2.8 1.04-4l.72.4Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".5",
    d: "M1.3 8c0 1.28.32 2.56.96 3.6l-.64.48A8.015 8.015 0 0 1 .5 8h.8Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".6",
    d: "M4.5 14.96a8.273 8.273 0 0 1-2.88-2.88l.64-.48c.64 1.12 1.52 2 2.64 2.64l-.4.72Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".7",
    d: "M8.5 16c-1.44 0-2.8-.4-4-1.04l.4-.72c1.04.64 2.32.96 3.6.96v.8Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".9",
    d: "M12.1 14.24c1.12-.64 2-1.52 2.64-2.64l.72.4a8.273 8.273 0 0 1-2.88 2.88l-.48-.64Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".8",
    d: "M8.5 15.2c1.28 0 2.56-.32 3.6-.96l.48.64C11.38 15.6 9.94 16 8.5 16v-.8Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".1",
    d: "M12.1 1.76C11.06 1.12 9.78.8 8.5.8V0c1.44 0 2.8.4 4 1.04l-.4.72Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.7 8.4c0-.24.24-.4.4-.4.24 0 .4.24.4.4-.08 1.28-.48 2.48-1.04 3.6l-.72-.4c.56-.96.88-2.08.96-3.2Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".05",
    d: "M15.22 3.6c.16.16.08.4-.08.56-.16.16-.4.08-.56-.08a7.624 7.624 0 0 0-2.48-2.32l.4-.72c1.04.64 2 1.52 2.72 2.56Z"
  }))), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h16v16H0z"
  })), /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#fff",
    transform: "translate(.5)",
    d: "M0 0h16v16H0z"
  }))));
};
LoadingIconTertiary.defaultProps = {
  width: "17",
  height: "16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var LoadingIconTextlink = function LoadingIconTextlink(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", props, /*#__PURE__*/_react["default"].createElement("g", {
    clipPath: "url(#a)",
    fill: "#007A73"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".2",
    d: "M3.145 1.184A5.61 5.61 0 0 1 6 .4v.56c-.896 0-1.792.224-2.52.672l-.336-.448Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".3",
    d: "M1.128 3.2a5.791 5.791 0 0 1 2.016-2.016l.336.448A4.88 4.88 0 0 0 1.632 3.48l-.504-.28Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".4",
    d: "M1.632 3.48C1.184 4.208.96 5.104.96 6H.4c0-1.008.28-1.96.728-2.8l.504.28Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".5",
    d: "M.96 6c0 .896.224 1.792.672 2.52l-.448.336A5.61 5.61 0 0 1 .4 6h.56Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".6",
    d: "M3.2 10.872a5.791 5.791 0 0 1-2.015-2.016l.448-.336a4.88 4.88 0 0 0 1.848 1.848l-.28.504Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".7",
    d: "M6 11.6c-1.008 0-1.96-.28-2.8-.728l.28-.504c.728.448 1.624.672 2.52.672v.56Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".9",
    d: "M8.52 10.368a4.88 4.88 0 0 0 1.848-1.848l.505.28a5.791 5.791 0 0 1-2.016 2.016l-.336-.448Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".8",
    d: "M6 11.04c.896 0 1.792-.224 2.52-.672l.336.448A5.61 5.61 0 0 1 6 11.6v-.56Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".1",
    d: "M8.52 1.632C7.792 1.184 6.896.96 6 .96V.4c1.008 0 1.96.28 2.8.728l-.28.504Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.04 6.28c0-.168.168-.28.28-.28.168 0 .28.168.28.28-.056.896-.336 1.736-.728 2.52l-.504-.28a5.216 5.216 0 0 0 .672-2.24Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    opacity: ".05",
    d: "M10.704 2.92c.112.112.056.28-.056.392-.111.112-.28.056-.391-.056A5.337 5.337 0 0 0 8.52 1.63l.28-.503a6.442 6.442 0 0 1 1.903 1.792Z"
  })), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#fff",
    transform: "translate(.4 .4)",
    d: "M0 0h11.2v11.2H0z"
  }))));
};
LoadingIconTextlink.defaultProps = {
  width: "12",
  height: "12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var LoadingIconMap = {
  Primary: /*#__PURE__*/_react["default"].createElement(LoadingIconPrimary, null),
  Secondary: /*#__PURE__*/_react["default"].createElement(LoadingIconSecondary, null),
  Tertiary: /*#__PURE__*/_react["default"].createElement(LoadingIconTertiary, null),
  Textlink: /*#__PURE__*/_react["default"].createElement(LoadingIconTextlink, null)
};
var ArrowIconMap = {
  Textlink: /*#__PURE__*/_react["default"].createElement(ArrowIconTextlink, null)
};

/**
 * Primary UI component for user interaction - Nova edition
 * NT2-19792 Dev | Button
 * https://www.figma.com/design/2N4gMTqYSm9oGSouVxbvCW/Nutrafol---Website-2024?node-id=554-29248&t=OSU479f3QIEQGJ3w-1
 */
var ButtonNova = function ButtonNova(_ref) {
  var level = _ref.level,
    ctaLink = _ref.ctaLink,
    icon = _ref.icon,
    className = _ref.className,
    label = _ref.label,
    size = _ref.size,
    width = _ref.width,
    srlabel = _ref.srlabel,
    loading = _ref.loading,
    disabled = _ref.disabled,
    trackObject = _ref.trackObject,
    onClick = _ref.onClick,
    copyClassName = _ref.copyClassName,
    children = _ref.children,
    customIcon = _ref.customIcon,
    props = _objectWithoutProperties(_ref, _excluded);
  var trackFn = function trackFn() {};
  var isLinked = !!ctaLink && !(ctaLink !== null && ctaLink !== void 0 && ctaLink.indexOf("#")) !== -1;
  var LoadingIcon = LoadingIconMap[level] || /*#__PURE__*/_react["default"].createElement(LoadingIconSecondary, null);
  var ArrowIcon = ArrowIconMap[level] || /*#__PURE__*/_react["default"].createElement(ArrowIconPrimary, null);
  var CustomIcon = customIcon || null;
  var disabledCls = disabled ? "disabled" : "";
  if (trackObject) {
    var obj = _objectSpread({
      type: "button"
    }, trackObject);
    obj.text = trackObject.text || label.replace(/(<([^>]+)>)/gi, "");
    delete obj.name;
    trackFn = function trackFn() {
      (0, _segmentfunctions.segmentEvent)(trackObject.name, obj);
    };
  }
  var onClickNew = function onClickNew() {
    try {
      trackFn();
    } catch (e) {
      //  trackFn() error
    }
    if (typeof onClick === "function") {
      onClick.apply(this, arguments);
    }
  };
  var linkProps = isLinked ? {
    as: _Linked.Linked,
    href: ctaLink
  } : {};

  //if no left or right icon passed, replace label on loading event
  var LabelOrLoader = function LabelOrLoader() {
    return loading && !["Right", "Left"].includes(icon) ? /*#__PURE__*/_react["default"].createElement(_ButtonNova.LoadingWrap, {
      className: "Only ".concat(size, " ").concat(level)
    }, LoadingIcon) : /*#__PURE__*/_react["default"].createElement(_TextElementNova.TextElementNova, {
      text: label,
      element: "span",
      className: "".concat(copyClassName, " ").concat(level, " ").concat(size === "Small" ? "CTA-10-Dia-Normal" : "CTA-20-Dia-Normal", " label")
    });
  };
  return /*#__PURE__*/_react["default"].createElement(_ButtonNova.WildButtonNova, _extends({
    style: {
      width: width
    },
    "aria-label": srlabel || label,
    type: ctaLink ? undefined : "button",
    className: [className ? className.replace(/undefined/g, "") : "", level, size, icon || "Noicon", loading ? "loading" : "", disabledCls, "ButtonNova"].join(" "),
    onClick: onClickNew
  }, props, linkProps), ["Only", "Left"].includes(icon) ? loading ? /*#__PURE__*/_react["default"].createElement(_ButtonNova.LoadingWrap, {
    className: "left ".concat(level)
  }, LoadingIcon) : /*#__PURE__*/_react["default"].createElement(_ButtonNova.ArrowWrap, {
    className: "left ".concat(level, " ").concat(disabledCls)
  }, CustomIcon ? CustomIcon : ArrowIcon) : null, icon === "Only" ? null : LabelOrLoader(), srlabel ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "aria-invisible"
  }, srlabel) : null, !label && children && /*#__PURE__*/_react["default"].createElement(_ButtonNova.ChildrenWrapper, null, children), icon === "Right" ? loading ? /*#__PURE__*/_react["default"].createElement(_ButtonNova.LoadingWrap, {
    className: "right ".concat(level)
  }, LoadingIcon) : /*#__PURE__*/_react["default"].createElement(_ButtonNova.ArrowWrap, {
    className: "right ".concat(level, " ").concat(disabledCls)
  }, CustomIcon ? CustomIcon : ArrowIcon) : null);
};
exports.ButtonNova = ButtonNova;
ButtonNova.propTypes = {
  /**
   * Is this the Primary, Secondary, Tertiary, Textlink
   */
  level: _propTypes["default"].oneOf(["Primary", "Secondary", "Tertiary", "Textlink"]),
  /**
   * if it has a left arrow
   */
  icon: _propTypes["default"].oneOf(["Left", "Right", "Only"]),
  /**
   * size
   */
  size: _propTypes["default"].oneOf(["Default", "Small"]),
  /**
   * is it a link
   */
  ctaLink: _propTypes["default"].string,
  /**
   * width eg 100%
   */
  width: _propTypes["default"].string,
  /**
   *  className
   */
  className: _propTypes["default"].string,
  /**
   * Button contents
   */
  label: _propTypes["default"].string,
  /**
   * Button screen reader copy
   */
  srlabel: _propTypes["default"].string,
  /**
   * if it is loading
   */
  loading: _propTypes["default"].bool,
  /**
   * if it is disabled
   */
  disabled: _propTypes["default"].bool,
  /**
   * Segments trackObject object e.g. {destination: '/quiz', name: "Marketing CTA Clicked"}.
   */
  trackObject: _propTypes["default"].object,
  /**
   * Optional click handler
   */
  onClick: _propTypes["default"].func,
  /**
   * Optional span copy classes
   */
  copyClassName: _propTypes["default"].string
};
ButtonNova.defaultProps = {
  level: "Primary",
  size: "Default",
  width: "auto",
  disabled: false,
  loading: false,
  ctaLink: "",
  copyClassName: ""
};